import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/utils/api";
import { SystemUserRole } from "@/schemas/systemUserRole";

export interface InviteResult {
  email: string;
  success: boolean;
  error: string | null;
}

export interface TeamInviteResponse {
  results: InviteResult[];
  successfulCount: number;
  failedCount: number;
}

export interface TeamInviteRequest {
  emails: string[];
  role: SystemUserRole;
}

// Team invite mutation
export const useTeamInvite = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (data: TeamInviteRequest): Promise<TeamInviteResponse> => {
      const response = await api.post<TeamInviteResponse>("/team-invite", data);
      return response.data;
    },
    onSuccess: () => {
      // Refresh the users list after successful invitations
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
};